import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { ActivatedRoute } from "@angular/router";
import { Subscription } from "rxjs";
import { GadgetApiService, GadgetsService, PageNotificationService } from '@signature-it/ngx-generic/services';
import { GadgetFilterDTO } from '@signature-it/ngx-generic/models';
import { GenericConfig, EntityConfig} from '@signature-it/ngx-generic/config';

declare let _: any;

@Component({
    selector: 'trend-bar-gadget',
    templateUrl: './trend-bar.gadget.html',
    styleUrls: ['./trend-bar.gadget.scss'],
    standalone: false
})
export class TrendBarGadget implements OnInit, OnDestroy{
    @Input() key: string;
    @Input() url: string;
    @Input() title: string;
    @Input() filterName: string;
    @Input() dataType: string;
    gadgetFilterSubscription: Subscription;
    @Input() dataConfig: Array<any> = [];
    entryKeys: Array<any> = [];
    qtyFilters: number = 0;
    serverSideFilter: Array<GadgetFilterDTO> = [];
    filters: GadgetFilterDTO;
    percent: Array<any>;
    moreInfoUrl: string = '';
    moreInfoFragment: string = '#';

    trendBarData: object = {};
    constructor(protected gadgetApiSvc: GadgetApiService,
                protected notifySvc: PageNotificationService,
                protected route: ActivatedRoute,
                protected gadgetSvc: GadgetsService,
                protected viewportScroller: ViewportScroller
    ) {

    }

    ngOnInit() {
        this.filterName = this.filterName || 'TrendBar';
        this.key = this.key || 'gadget-events';
        let gadgetConfig = EntityConfig.ngxGadgets['gadgets'] && EntityConfig.ngxGadgets['gadgets'].find(x => x.type === 'TrendBar' && x.key === this.key)
            || GenericConfig.gadgets.find(x => x.type === 'TrendBar' && x.key === this.key);
        this.url = this.url || gadgetConfig.url;
        this.title = this.title || gadgetConfig.title;
        this.dataType = this.dataType || gadgetConfig.dataType;
        this.qtyFilters = GenericConfig.filterGadget.filter(x => x.name === this.filterName && x.serverSide ).length;
        this.dataConfig = this.dataConfig.length ? this.dataConfig : gadgetConfig.data;
        this.dataConfig = _.sortBy(this.dataConfig, (o) => { return o.order; })
        this.entryKeys = this.dataConfig;
        this.getData();
    }

    getData() {
        this.gadgetFilterSubscription = this.gadgetSvc.gadgetFilter.subscribe(gadgetFilter => {
            let serverSideFilter = _.filter(gadgetFilter, (filter: any) => filter.name === this.filterName && filter.serverSide);
            if (serverSideFilter) {
                if (_.has(serverSideFilter, '[0].value') && !serverSideFilter[0].value ) {
                    this.route.queryParams.subscribe(params => {
                        //TODO change to loop
                        if (params) {
                            this.serverSideFilter.push( new GadgetFilterDTO(serverSideFilter[0]));
                            this.serverSideFilter[0].value = params[this.serverSideFilter[0].key];
                            if (this.gadgetSvc.hasParams(this.serverSideFilter)) {
                                this.getTrendBar();
                            }
                        }
                    });
                }
                else if (!this.serverSideFilter || !this.serverSideFilter.length || this.gadgetSvc.compareVal(serverSideFilter, this.serverSideFilter)) {
                    this.serverSideFilter = [];
                    serverSideFilter.forEach(dataFilter => {
                        this.serverSideFilter.push(new GadgetFilterDTO(dataFilter))
                    });
                    // this.serverSideFilter = new GadgetFilterDTO(serverSideFilter);
                    if (this.gadgetSvc.hasParams(this.serverSideFilter) && this.serverSideFilter.length == this.qtyFilters) {
                        this.getTrendBar();
                    }
                }
            }

            let filters = _.find(gadgetFilter, (filter: any) => filter.name === this.filterName && !filter.serverSide);
            if (filters != this.filters) {
                this.filters = _.cloneDeep(filters);
                this.setPercent();
            }
        });
    }


    compareVal(arr) {
        let data = arr.filter(({ value: val1 }) => !this.serverSideFilter.some(({ value: val2 }) => val2 != val1));
        return data.length;
    }

    withoutTime() {
        let date = new Date();
        date.setHours(0, 0, 0, 0);
        return date;
    }

    hasParams() {
        return this.serverSideFilter.every( d  => !!d.value);
    }

    getTrendBar() {
        let data = {date: this.withoutTime()};
        this.serverSideFilter.forEach(dataFilter => {
            data[dataFilter.key] = dataFilter.value;
        });
        // data[this.serverSideFilter.key] = this.serverSideFilter.value;

        this.gadgetApiSvc.getTrendBar(data, this.url)
            .subscribe(
                res => {
                    if (res && res.length) {
                       this.trendBarData = _.chain(res)
                            .groupBy('entry_key')
                            .mapValues(values => _.chain(values)
                                .groupBy(this.filters['key'])
                                .value()
                            )
                            .value();
                       this.reduceEmptyData();
                        this.setPercent();
                        console.log('this.trendBarData', this.trendBarData);
                    } else if (Object(res)) {
                        this.dataType = 'obj';
                        this.trendBarData = res;
                        this.setPercent();
                    } else {
                        // this.notifySvc.set('Some Error Occurred').show();
                    }
                },
                error => {
                    // this.notifySvc.set(error).show();
                }
            );
    }

    setPercent() {
        this.percent = [];
        this.dataConfig.forEach((data) => {
            let entryKey = data.entry_key;
            if (this.trendBarData[entryKey] && this.trendBarData[entryKey][`prev_${this.filters.value}` ]) {
                let decimalPoints = this.dataConfig.find(data => data.entry_key == entryKey).decimal_points || 2.;
                if (this.trendBarData[entryKey][this.filters.value]) {
                    let prev = +this.trendBarData[entryKey][`prev_${this.filters.value}`][0].total;
                    let current = +this.trendBarData[entryKey][this.filters.value][0].total;
                    if (current) {
                        if ( prev ) {
                            this.percent[entryKey] = ((current - prev)/ prev * 100).toFixed(decimalPoints);
                            // this.percent[entryKey] = (+this.trendBarData[entryKey][this.filters.value][0].total * 100 /+this.trendBarData[entryKey][`prev_${this.filters.value}`][0].total - 100).toFixed(decimalPoints);
                        }
                    }
                } else {
                    this.percent[entryKey] = -100;
                }
            } else {

            }
        });
    }

    ngOnDestroy() {
        this.gadgetFilterSubscription.unsubscribe();
    }

    reduceEmptyData() {
        let newDataConfig = [], emptyData = [];
        this.dataConfig.forEach((data) => {
            let entryKey = data.entry_key;
            if (this.trendBarData[entryKey]){
                newDataConfig.push(data);
            } else {
                emptyData.push(data);
            }
        });

        for(let i = newDataConfig.length, j=0; i<3; i++,j++) {
            newDataConfig.push(emptyData[j]);
        }

        this.dataConfig = this.entryKeys = newDataConfig;
    }

    scrollTo(elementId) {
        this.viewportScroller.scrollToAnchor(elementId);
    }
}
